import React from 'react';
import { DraggableComponentProps } from 'features/document/constants';
import { v4 as uuidv4 } from 'uuid';
import { isCheckboxElement } from 'utils/typeGuards';
import { CheckboxContainer, Input, Label } from './Checkbox.styled';

export default function CheckBox({ currentElement }: DraggableComponentProps) {
  if (!isCheckboxElement(currentElement)) {
    return null;
  }

  const groupDirection = currentElement.content.groupDirection;

  return (
    <CheckboxContainer
      style={{
        alignItems: groupDirection === 'horizontal' ? 'center' : 'flex-start',
        flexDirection: groupDirection === 'vertical' ? 'column' : 'row',
      }}
    >
      {currentElement.content.elements.map(element => (
        <Label key={uuidv4()}>
          <Input readOnly type='checkbox' name='checkbox' checked={element.checked} />
          {element.label}
        </Label>
      ))}
    </CheckboxContainer>
  );
}
